import React from 'react';
import { Nav, Navbar, Form, FormControl } from 'react-bootstrap';
import styled from 'styled-components';

// Style for the Navigation Bar
const Styles = styled.div`
  .navbar {
      background-color: #2C2F33;
      border-bottom: solid 3px #00b0f0;
    }
   #navimage{
       width: auto;
       height: 80px;
   }

  a, .navbar-nav, .navbar-light .nav-link {
    color: #FFFFFF;
    &:hover { color: white; } 
  }
  .navbar-brand {
    font-size: 1.4em;
    color: #FFFFFF;
    &:hover { color: white; }
  }
  .form-center {
    position: absolute !important;
    left: 25%;
    right: 25%;
  }
`;

export const NavigationBar = () => (
  <Styles>
    <Navbar expand="lg">
      <a href="/">
        <img className="img-fluid" src={`${process.env.PUBLIC_URL}/nav_logo.png`} id="navimage" alt=""></img>
      </a>
      <Navbar.Toggle aria-controls="basic-navbar-nav"/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Item><Nav.Link href="/dashboard">My Dashboard</Nav.Link></Nav.Item> 
          <Nav.Item><Nav.Link href="/create-task">Create Task</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link href="/profile">Profile</Nav.Link></Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </Styles>
)